const investorContactLang = {
	client_service: {
		tag: 'investor.contact.client_service',
		fr: 'Relation client',
		en: 'Client relationship',
	},
	investor_relationship: {
		tag: 'investor.contact.investor_relationship',
		fr: 'Relation investisseur',
		en: 'Investor relationship',
	},
	middle_office_manager: {
		tag: 'investor.contact.middle_office_manager',
		fr: 'Gestionnaire Middle Office',
		en: 'Middle Office Manager',
	},
	mcci: {
		tag: 'investor.contact.mcci',
		fr: 'RCCI',
		en: 'MCCI',
	},
};

export default investorContactLang;
